import { render, staticRenderFns } from "./IndexSetting.vue?vue&type=template&id=eed0a030&scoped=true&"
import script from "./IndexSetting.vue?vue&type=script&lang=js&"
export * from "./IndexSetting.vue?vue&type=script&lang=js&"
import style0 from "./IndexSetting.vue?vue&type=style&index=0&id=eed0a030&scoped=true&lang=css&"
import style1 from "./IndexSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed0a030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eed0a030')) {
      api.createRecord('eed0a030', component.options)
    } else {
      api.reload('eed0a030', component.options)
    }
    module.hot.accept("./IndexSetting.vue?vue&type=template&id=eed0a030&scoped=true&", function () {
      api.rerender('eed0a030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/SettingChildred/IndexSetting.vue"
export default component.exports